import { useRef } from 'react';
import { Drawer, Portal, CloseButton } from '@chakra-ui/react';
import Sidebar from '@/components/sidebar';

export default function ToolsDrawer({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {
  // Select/Combobox dropdowns inside the drawer must portal into the drawer's
  // content, not document.body — the modal drawer treats body-portalled
  // dropdowns as "outside" and they become untappable on touch devices.
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <Drawer.Root open={isOpen} size='sm' placement='bottom' onOpenChange={(e) => { if (!e.open) onClose(); }}>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content ref={contentRef}>
            <Drawer.Header>
              <Drawer.CloseTrigger asChild>
                <CloseButton size='md' />
              </Drawer.CloseTrigger>
              <Drawer.Title>Actions</Drawer.Title>
            </Drawer.Header>
            <Drawer.Body paddingTop='0' paddingLeft='3' paddingBottom='6'>
              <Sidebar onClose={onClose} portalRef={contentRef} />
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}
